import { useEffect } from 'react';

import { useAppContext } from './useAppContext';
import { useSearchStore } from './stores/search/useSearchStore';
import { SearchMode } from './stores/search/slices/searchModeSlice';
import { useShopsByIds } from './queries/useShopsByIds';
import { useListings } from './queries/useListings';
import { sendTrackSiteSearchEvent } from '../utils/tracking';
import { mapSearchStateToSearchListingsFilters } from '../utils/mapFilterFields';
import { useMapVisibilityStore } from '../providers/MapVisibilityStoreProvider';

export const useTrackInitialSiteSearchEvent = () => {
  const placeName = useSearchStore((state) => state.placeName);
  const { shopNames } = useShopsByIds();
  const getStateSnapshot = useSearchStore((state) => state.getStateSnapshot);
  const searchMode = useSearchStore((state) => state.searchMode);
  const { data: results } = useListings();
  const {
    tracking,
    options: { currency, measurementSystem, language },
    countryCode,
  } = useAppContext();

  const isMapToggledOn = useMapVisibilityStore((state) => state.isMapActive);

  useEffect(() => {
    if (!tracking?.isSnowplowInitialized) return;

    const stateSnapshot = getStateSnapshot();

    sendTrackSiteSearchEvent({
      results,
      filters: mapSearchStateToSearchListingsFilters(stateSnapshot),
      options: {
        currency,
        measurementSystem,
        language,
      },
      shopNames,
      placeName,
      tracking,
      countryCode,
      isMapToggledOn,
      searchMode: searchMode ?? SearchMode.CLASSIC,
      sortingOptionId: stateSnapshot.sortingOptionId,
    });
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, [tracking?.isSnowplowInitialized]);
};
